$(document).ready(function () {
  const $btn = $("#btn-generate-description");
  if (!$btn.length) return;

  // Classe original do botão (definida na view)
  const originalClass = $btn.attr("class");
  const originalHtml  = $btn.html();

  $btn.on("click", function () {
    const url  = $btn.data("url");
    const $area = $("#publication_description");
    const startTime = performance.now();

    console.info("[generate_description] Iniciando requisição...", { url: url });

    // Estado de loading — a chamada à IA pode levar alguns segundos
    $btn.prop("disabled", true)
        .attr("class", "btn btn-sm btn-secondary ml-2")
        .html('<i class="fa fa-spinner fa-spin"></i> IA gerando...');

    $.ajax({
      url: url,
      type: "GET",
      dataType: "json",
      timeout: 90000, // 90s para dar margem à OpenAI
      headers: {
        "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
      },
    })
      .done(function (data, textStatus, xhr) {
        const elapsed = ((performance.now() - startTime) / 1000).toFixed(2);
        console.info("[generate_description] Resposta recebida em " + elapsed + "s", {
          status: xhr.status,
          warning: data.warning || null,
          descriptionLength: data.description ? data.description.length : 0,
        });

        $area.val(data.description);

        // Aviso se a IA falhou e usou fallback
        if (data.warning) {
          console.warn("[generate_description] Fallback usado:", data.warning);
        }

        // Feedback de sucesso
        $btn
          .attr("class", "btn btn-sm btn-success ml-2")
          .html('<i class="fa fa-check"></i> Gerado pela IA!');

        setTimeout(function () {
          $btn
            .attr("class", originalClass)
            .html(originalHtml)
            .prop("disabled", false);
        }, 2500);
      })
      .fail(function (xhr, status, errorThrown) {
        const elapsed = ((performance.now() - startTime) / 1000).toFixed(2);
        const isTimeout = status === "timeout";

        console.error("[generate_description] Falha após " + elapsed + "s", {
          status: status,
          httpStatus: xhr.status,
          statusText: xhr.statusText,
          errorThrown: errorThrown,
          isTimeout: isTimeout,
          responseText: xhr.responseText || "(vazio)",
        });

        if (isTimeout) {
          console.error("[generate_description] TIMEOUT: A requisição excedeu 90s. Verifique o tempo de resposta da API OpenAI nos logs do servidor.");
        }

        const msg = isTimeout
          ? "A IA demorou muito para responder (>90s). Tente novamente."
          : "Erro ao gerar descrição com IA (HTTP " + xhr.status + "). Tente novamente.";

        alert(msg);
        $btn
          .attr("class", originalClass)
          .html(originalHtml)
          .prop("disabled", false);
      });
  });
});
